import { render, staticRenderFns } from "./OrganizationLink.vue?vue&type=template&id=62e18f06&"
import script from "./OrganizationLink.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports